import { takeEvery, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  tourCruiseLinesRequest,
  tourCruiseLinesSuccess,
  tourCruiseLinesFail,
} from '../../slices/tour';

function* tourCruiseLinesWorker() {
  try {
    const { data } = yield call(axios, { method: 'get', url: '/tours/cruises' });
    yield put(tourCruiseLinesSuccess({ response: data }));
  } catch (error) {
    yield put(tourCruiseLinesFail({ error: `${error}` }));
  }
}

function* tourCruiseLinesWatcher() {
  yield takeEvery(tourCruiseLinesRequest.toString(), tourCruiseLinesWorker);
}

export default tourCruiseLinesWatcher;
